import React from 'react'

const Spinner = () => {
  return (
    <div className=' flex justify-center items-center py-60'>
        <div className='spinner'>

        </div>
    </div>
  )
}

export default Spinner